<i18n>
  {
  "ru": {
  "addItem": "Добавить страницу",
  "name": "Название",
  "image": "Изображение",
  "search": "Поиск",
  "desc": "Описание",
  "included_in": "Входит в (категория)",
  "globalCheck": "глобально",
  "deadline": "Срок показа",
  "pin": "закрепить",
  "position": "Позиция",
  "create": "Создать",
  "update": "Обновить",
  "close": "Закрыть",
  "status": {
    "default" : "Выберите статус",
    "active" : "Активный",
    "disable": "Выключена"
  }
  },
  "uk": {
  "addItem": "Додати сторінку",
  "name": "Назва",
  "image": "Зображення",
  "search": "Пошук",
  "desc": "Опис",
  "included_in": "Входить в (категорія)",
  "globalCheck": "глобально",
  "deadline": "Термін показу",
  "position": "Позиція",
  "pin": "закріпити",
  "create": "Створити",
  "update": "Оновити",
  "close": "Закрити",
  "status": {
    "default" : "Виберіть статус",
    "active" : "Активний",
    "disable": "Вимкнений"
  }
  }
  }
</i18n>
<template>
  <div>
    <div class="row">
      <div class="col-md-12 change-lang">
        <router-link class="locale" :to="{ params: { locale: 'ru' } }">
          <img
            src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYBAMAAAASWSDLAAAAGFBMVEVHcEz/PgDf4eGqsdKASnn/PQDg4eI/UbUIMKX5AAAABXRSTlMAgIDAwJ6ZvvQAAAA3SURBVBjTY2AgAzApwYECA1saHCQQy2E2hgMDBvZyOCgglsPiAgcODKyhcBBALIdREA4EyAkCAFaFO+fKN2UpAAAAAElFTkSuQmCC"
          />
          Русский</router-link
        >
        <router-link class="locale" :to="{ params: { locale: 'uk' } }"
          ><img
            src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYBAMAAAASWSDLAAAAD1BMVEVHcEz91zYilfMhlvP92DVw3Q5rAAAAA3RSTlMAgIAsTd+1AAAAJklEQVQY02NgIAMwKcGBAgOzMRwYUJnD4gIHDlTmMArCgQA5QQAAdeEl/Xx287cAAAAASUVORK5CYII="
          />
          Украинский</router-link
        >
      </div>
    </div>
    <div class="btn-block-top row">
      <div class="col-md-3"></div>
      <div class="col-md-9">
        <button class="btn btn-primary" @click.prevent="showAdd = !showAdd">
          {{ $t("addItem") }}
        </button>
      </div>
    </div>
    <div class="create-block" v-if="showAdd">
      <b-card>
        <form @submit.prevent="addAds">
          <div class="row">
            <div class="form-group col-md-6">
              <label>{{ $t("name") }}:</label>
              <input
                type="text"
                name="name"
                required
                class="form-control"
                v-model="form.name[locale]"
                v-on:keyup="nameToUrl('add')"
              />
            </div>
            <div class="form-group col-md-6">
              <label>URL:</label>
              <input
                type="text"
                name="name"
                class="form-control"
                v-model="form.url[locale]"
              />
            </div>
          </div>
          <div class="form-group">
            <label>{{ $t("included_in") }}:</label>
            <select class="form-control" v-model="form.cat_id">
              <option value="footer">Низ сайта</option>
              <template v-for="cat in $store.state.GlobalData.categories">
                <option
                  v-if="cat.typePage === 1"
                  :key="cat.id"
                  :value="cat.id"
                  >{{ cat.name[locale] }}</option
                >
              </template>
            </select>
          </div>
          <div class="form-group">
            <label>{{ $t("image") }}:</label>
            <file-pond
              name="image"
              ref="pond"
              label-idle="Для загрузки кликни или перетащи файл..."
              allow-multiple="true"
              allowImageResize="true"
              imageResizeTargetWidth="800"
              imageResizeTargetHeight="600"
              imageResizeUpscale="false"
              accepted-file-types="image/jpg, image/jpeg, image/png"
              server="https://may-ua.com.ua/uploader/upload.php"
              v-bind:files="myFiles"
              @processfile="onLoad"
            />
          </div>
          <div class="form-group">
            <label>{{ $t("desc") }}:</label>
            <ckeditor
              :editor="ck.editor"
              v-model="form.description[locale]"
              :config="ck.editorConfig"
            >
            </ckeditor>
            <span class="text-success"
              >{{ form.description[locale].length }} символов</span
            >
          </div>
          <div class="form-check">
            <input
              type="checkbox"
              id="globalCheck"
              class="form-check-input"
              v-model="form.global"
            />
            <label for="globalCheck" class="form-check-label">
              {{ $t("globalCheck") }}
            </label>
          </div>
          <div class="form-check">
            <input
              type="checkbox"
              id="pinCheck"
              class="form-check-input"
              v-model="form.pin"
              @change="pinShow = !pinShow"
            />
            <label for="pinCheck" class="form-check-label">
              {{ $t("pin") }}
            </label>
          </div>
          <div class="row" v-show="pinShow">
            <div class="col-md-6">
              <div class="form-group">
                <label>{{ $t("deadline") }}:</label>
                <v-md-date-range-picker
                  @change="changeDate"
                ></v-md-date-range-picker>
              </div>
            </div>
            <div class="form-group col-md-6">
              <label>{{ $t("position") }}:</label>
              <input
                type="number"
                class="form-control"
                v-model.number="form.position"
              />
            </div>
          </div>
          <div class="btn-actions">
            <button type="submit" class="btn btn-primary btn-sm">
              {{ $t("create") }}
            </button>
            <button
              type="button"
              class="btn btn-link btn-sm"
              @click.prevent="showAdd = !showAdd"
            >
              {{ $t("close") }}
            </button>
          </div>
        </form>
      </b-card>
    </div>
    <div class="as-datatable">
      <div class="col-md-4 npd">
        <div class="form-group">
          <input
            :placeholder="$t('search')"
            type="text"
            class="form-control"
            v-model="liveSearch"
          />
        </div>
      </div>
      <b-table
        v-if="$store.state.GlobalData.ads"
        bordered
        striped
        hover
        small
        :busy="!isBusy"
        :items="filteringItem"
        :fields="fields"
        :current-page="currentPage"
        :per-page="perPage"
      >
        <template v-slot:cell(name)="row">
          {{ row.item.name[locale] }}
        </template>
        <template v-slot:cell(url)="row">
          {{ row.item.url[locale] }}
        </template>
        <template v-slot:cell(image)="row">
          <img class="td_image" :src="row.item.image" />
        </template>
        <template v-slot:cell(status)="row">
          <span class="text-success" v-if="row.item.status == 1">Активная</span>
          <span class="text-danger" v-else-if="row.item.status == 2"
            >Удалена</span
          >
        </template>
        <template v-slot:cell(actions)="row">
          <div class="btn-actions">
            <button @click="toggleEdit(row)" class="btn btn-primary btn-sm">
              <font-awesome-icon
                v-if="!row.detailsShowing"
                class="as-icon"
                :icon="['fas', 'pencil-alt']"
              />
              <font-awesome-icon
                v-else
                class="as-icon"
                :icon="['far', 'eye-slash']"
              />
            </button>

            <button
              class="btn btn-danger btn-sm"
              @click.prevent="removeEl(row)"
            >
              <font-awesome-icon class="as-icon" :icon="['fas', 'trash-alt']" />
            </button>
          </div>
        </template>
        <template v-slot:row-details="row">
          <b-card>
            <form action="#" method="POST" @submit.prevent="savePost(row)">
              <div class="row">
                <div class="form-group col-md-6">
                  <label>{{ $t("name") }}:</label>
                  <input
                    type="text"
                    name="name"
                    required
                    class="form-control"
                    v-model="row.item.name[locale]"
                  />
                </div>
                <div class="form-group col-md-6">
                  <label>URL:</label>
                  <input
                    type="text"
                    name="name"
                    class="form-control"
                    v-model="row.item.url[locale]"
                  />
                </div>
              </div>
              <div class="form-group">
                <label>{{ $t("included_in") }}:</label>
                <select class="form-control" v-model="row.item.cat_id">
                  <option value="footer">Низ сайта</option>
                  <template v-for="cat in $store.state.GlobalData.categories">
                    <option
                      v-if="cat.typePage === 1"
                      :key="cat.id"
                      :value="cat.id"
                      >{{ cat.name[locale] }}</option
                    >
                  </template>
                </select>
              </div>
              <div class="form-group">
                <label>{{ $t("image") }}:</label>
                <file-pond
                  name="image"
                  ref="pond"
                  label-idle="Для загрузки кликни или перетащи файл..."
                  allow-multiple="true"
                  allowImageResize="true"
                  imageResizeTargetWidth="800"
                  imageResizeTargetHeight="600"
                  imageResizeUpscale="false"
                  accepted-file-types="image/jpeg, image/png"
                  :server="{
                    process: 'https://may-ua.com.ua/uploader/upload.php',
                    load:
                      'https://s3.eu-central-1.amazonaws.com/img.baby/products/'
                  }"
                  @processfile="onLoadEdit"
                  @removefile="removeFileEdit"
                  v-bind:files="row.item.kostil"
                />
              </div>
              <div class="form-group">
                <label>{{ $t("desc") }}:</label>
                <ckeditor
                  :editor="ck.editor"
                  v-model="row.item.description[locale]"
                  :config="ck.editorConfig"
                >
                </ckeditor>
                <span class="text-success"
                  >{{ row.item.description[locale].length }} символов</span
                >
              </div>
              <div class="form-check">
                <input
                  type="checkbox"
                  id="globalCheck"
                  class="form-check-input"
                  v-model="row.item.global"
                />
                <label for="globalCheck" class="form-check-label">
                  {{ $t("globalCheck") }}
                </label>
              </div>
              <div class="form-check">
                <input
                  type="checkbox"
                  id="pinCheck"
                  class="form-check-input"
                  v-model="row.item.pin"
                />
                <label for="pinCheck" class="form-check-label">
                  {{ $t("pin") }}
                </label>
              </div>
              <div class="row" v-show="row.item.pin">
                <div class="col-md-6">
                  <div class="form-group">
                    <label>{{ $t("deadline") }}:</label>
                    <v-md-date-range-picker
                      :start-date="row.item.range[0]"
                      :end-date="row.item.range[1]"
                      v-model.number="row.item.range"
                      @change="changeDate"
                    ></v-md-date-range-picker>
                  </div>
                </div>
                <div class="form-group col-md-6">
                  <label>{{ $t("position") }}:</label>
                  <input
                    type="number"
                    class="form-control"
                    v-model.number="row.item.position"
                  />
                </div>
              </div>
              <div class="form-group">
                <label>Статус:</label>
                <select
                  class="form-control"
                  name="status"
                  v-model="row.item.status"
                >
                  <option value="default">{{ $t("status.default") }}</option>
                  <option value="1" :selected="row.item.status === 1">{{
                    $t("status.active")
                  }}</option>
                  <option value="2" :selected="row.item.status === 2">{{
                    $t("status.disable")
                  }}</option>
                </select>
              </div>
              <div class="btn-actions">
                <button
                  class="btn btn-primary btn-sm"
                  type="submit"
                  :disabled="row.item.ready"
                >
                  {{ $t("update") }}
                </button>
                <button
                  class="btn btn-link btn-sm"
                  type="button"
                  @click.prevent="row.toggleDetails"
                >
                  {{ $t("close") }}
                </button>
              </div>
            </form>
          </b-card>
        </template>
      </b-table>
      <b-row v-if="$store.state.GlobalData.ads">
        <b-col md="6" class="my-1">
          <b-pagination
            v-model="currentPage"
            :total-rows="$store.state.GlobalData.ads.length"
            :per-page="perPage"
            class="my-0"
          ></b-pagination>
        </b-col>
      </b-row>
      <p class="text-danger text-center" v-else>Объявления отсутствуют...</p>
    </div>
  </div>
</template>
<script>
import { slugify } from "transliteration";
import vueFilePond from "vue-filepond";
import "filepond/dist/filepond.min.css";
import "filepond-plugin-image-preview/dist/filepond-plugin-image-preview.min.css";
import FilePondPluginFileValidateType from "filepond-plugin-file-validate-type";
import FilePondPluginImagePreview from "filepond-plugin-image-preview";
import FilePondPluginImageResize from "filepond-plugin-image-resize";
import FilePondPluginImageTransform from "filepond-plugin-image-transform";
import Axios from "axios";

const FilePond = vueFilePond(
  FilePondPluginFileValidateType,
  FilePondPluginImagePreview,
  FilePondPluginImageResize,
  FilePondPluginImageTransform
);
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
class UploadAdapter {
  constructor(loader) {
    this.loader = loader;
  }
  upload() {
    return this.loader.file.then(uploadedFile => {
      return new Promise((resolve, reject) => {
        const data = new FormData();
        data.append("image", uploadedFile);

        Axios({
          url: "https://may-ua.com.ua/uploader/upload.php",
          method: "post",
          data,
          headers: {
            "Content-Type": "multipart/form-data;"
          },
          withCredentials: false
        })
          .then(response => {
            if (response.status == 200) {
              resolve({
                default: response.data.full
              });
            } else {
              reject(response);
            }
          })
          .catch(response => {
            reject("Upload failed", response);
          });
      });
    });
  }
  abort() {}
}
export default {
  computed: {
    filteringItem() {
      const items = this.$store.state.GlobalData.ads;
      if (this.liveSearch) {
        return items.filter(f =>
          f.name[this.locale]
            ? f.name[this.locale]
                .toLowerCase()
                .indexOf(this.liveSearch.toLowerCase()) !== -1
            : null
        );
      } else {
        return items;
      }
    }
  },
  data() {
    return {
      locale: this.$route.params.locale,
      showAdd: false,
      pinShow: false,
      myFiles: [],
      liveSearch: "",
      form: {
        name: {
          ru: null,
          uk: null
        },
        url: {
          ru: null,
          uk: null
        },
        cat_id: null,
        image: null,
        description: {
          ru: "",
          uk: ""
        },
        global: false,
        pin: false,
        range: [],
        position: 0
      },
      ck: {
        editor: ClassicEditor,
        editorConfig: {
          extraPlugins: [this.MyCustomUploadAdapterPlugin],
          language: "ru"
        }
      },
      currentPage: 1,
      perPage: 20,
      isBusy: true,
      fields: [
        {
          key: "index",
          label: "№",
          sortable: false
        },
        {
          key: "name",
          label: "Название",
          sortable: false
        },

        {
          key: "url",
          label: "Url",
          sortable: false
        },
        {
          key: "status",
          label: "Статус",
          sortable: false
        },
        {
          key: "actions",
          label: "Действия",
          sortable: false
        }
      ]
    };
  },
  methods: {
    addAds() {
      this.form.status = 1;
      let _this = this;
      let store = this.$store.state.GlobalData.ads;
      this.form.city_id = this.$store.state.GlobalData.currentCity.id;
      Axios.post("/.netlify/functions/ads-create", this.form)
        .then(function(res) {
          _this.form.index = store ? store.length + 1 : 0;
          let newItem = {};
          _this.form.id = res.data.ref["@ref"].id;
          for (let key in _this.form) {
            newItem[key] = _this.form[key];
          }
          if (store === null) {
            store = new Array();
          }
          store.push(newItem);
          _this.showAdd = false;
          _this.form = clearForm();
        })
        .catch(function(err) {
          console.log(err);
        });
    },
    savePost(el) {
      el.item.ready = true;
      let form = {
        id: el.item.id,
        name: el.item.name,
        url: el.item.url,
        image: el.item.image,
        description: el.item.description,
        cat_id: el.item.cat_id,
        global: el.item.global,
        pin: el.item.pin,
        range: el.item.range,
        position: el.item.position,
        status: el.item.status
      };
      Axios.post("/.netlify/functions/ads-update", form)
        .then(function() {
          el.toggleDetails(false);
          el.item.ready = false;
        })
        .catch(function(err) {
          console.log(err);
        });
    },
    removeEl(el) {
      if (confirm("Вы уверены?")) {
        let _this = this;
        Axios.post("/.netlify/functions/ads-delete", { id: el.item.id })
          .then(function() {
            _this.$store.state.GlobalData.ads.filter((f, i) => {
              if (f.index === el.item.index) {
                _this.$store.state.GlobalData.ads.splice(i, 1);
              }
            });
          })
          .catch(function(err) {
            console.log(err);
          });
      } else {
        return null;
      }
    },
    changeDate(val) {
      this.form.range = [
        parseInt(new Date(val[0]._d).getTime()),
        parseInt(new Date(val[1]._d).getTime())
      ];
    },
    MyCustomUploadAdapterPlugin(editor) {
      editor.plugins.get("FileRepository").createUploadAdapter = loader => {
        return new UploadAdapter(loader);
      };
    },
    toggleEdit(row) {
      row.toggleDetails(true);
    },
    nameToUrl(type, item) {
      if (type === "add") {
        this.form.url[this.locale] = slugify(this.form.name[this.locale])
          .replace(/[^a-zA-Z0-9]/g, " ")
          .split(" ")
          .filter(f => f.trim().length > 0)
          .join("-");
      } else {
        item.url[this.locale] = slugify(item.name[this.locale])
          .replace(/[^a-zA-Z0-9]/g, " ")
          .split(" ")
          .filter(f => f.trim().length > 0)
          .join("-");
      }
    },
    onLoad(formData, file) {
      const image = JSON.parse(file.serverId).full;
      this.form.image = image;
    },
    onLoadEdit(formData, file) {
      let store = this.$store.state.GlobalData.ads;
      const image = JSON.parse(file.serverId).full;
      this.flag = true;
      for (let i = 0; i < store.length; i++) {
        if (store[i]._showDetails) {
          store[i].image = image;
          let obj = {
            source: image
              .split("/")
              .splice(5, 4)
              .join("/")
              .toString(),
            options: { type: "local" }
          };
          store[i].kostil = [obj];
          console.log(store[i]);
        }
      }
    },
    removeFileEdit() {
      if (!this.flag) {
        let store = this.$store.state.GlobalData.ads;
        for (let i = 0; i < store.length; i++) {
          if (store[i]._showDetails) {
            store[i].image = null;
            store[i].kostil = [];
          }
        }
      } else {
        this.flag = false;
      }
    }
  },
  watch: {
    $route(to) {
      this.locale = to.params.locale;
    }
  },
  components: {
    FilePond
  }
};
function clearForm() {
  let form = {
    name: {
      ru: null,
      uk: null
    },
    url: {
      ru: null,
      uk: null
    },
    cat_id: null,
    image: null,
    description: {
      ru: "",
      uk: ""
    },
    global: false,
    pin: false,
    range: [],
    position: 0
  };
  return form;
}
</script>
